import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import AdminLeadBrief from "@/pages/AdminLeadBrief";
import AdminGate from "@/components/AdminGate";

export const Route = createFileRoute("/admin/lead-brief")({
  head: () => seoHead("/admin/lead-brief"),
  component: () => (
    <AdminGate><AdminLeadBrief /></AdminGate>
  ),
});
